import ComplaintReceiver from './ComplaintReceiver'

export default ComplaintReceiver
